'use strict';

export default function(element) {
  // requirements are to provide your button and reveal target
  var buttons = element.find('[data-accordion-toggler-click]');
  var targets = element.find('[data-accordion-toggler-target]');
  var mediaQuery = '(min-width: 600px)';

  // default
  if (!window.matchMedia(mediaQuery).matches) {
    reset();
  }

  buttons.on('click', function(event) {
    event.preventDefault();
    handleStates($(this));
  });

  function handleStates(button) {
    buttons.each(function(index, el) {
      var next = button.next();
      if (el == button.get(0)) {
        button.toggleClass('active');
        if (next.css('display') == 'none') {
          next.removeClass('hide');
        } else {
          next.addClass('hide');
        }
      } else {
        $(el).removeClass('active');
        $(el)
          .next()
          .addClass('hide');
      }
    });
  }

  function reset() {
    buttons.each(function(index, el) {
      $(el).removeClass('active');
      $(el)
        .next()
        .addClass('hide');
    });
    handleStates($(buttons.get(0)));
  }

  var media = window.matchMedia(mediaQuery);

  media.addListener(function(data) {
    if (data.matches === true) {
      targets.each(function(index, el) {
        $(el).removeClass('hide');
      });
    } else {
      reset();
    }
  });
}
